"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDataAttApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class MaterialDataAttApi extends runtime.BaseAPI {
    /**
     * 商品資料管理-新增主圖(Att)
     */
    materialDataAttCreateMainPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['mdaMaterialAttNo'] != null) {
                queryParameters['MdaMaterialAttNo'] = requestParameters['mdaMaterialAttNo'];
            }
            if (requestParameters['mdaCategoryKey'] != null) {
                queryParameters['MdaCategoryKey'] = requestParameters['mdaCategoryKey'];
            }
            if (requestParameters['attCategory'] != null) {
                queryParameters['AttCategory'] = requestParameters['attCategory'];
            }
            if (requestParameters['mdaAppendixName'] != null) {
                queryParameters['MdaAppendixName'] = requestParameters['mdaAppendixName'];
            }
            if (requestParameters['mdaOrder'] != null) {
                queryParameters['MdaOrder'] = requestParameters['mdaOrder'];
            }
            if (requestParameters['mdaAppendixSource'] != null) {
                queryParameters['MdaAppendixSource'] = requestParameters['mdaAppendixSource'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            const response = yield this.request({
                path: `/MaterialDataAtt/CreateMain`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品資料管理-新增主圖(Att)
     */
    materialDataAttCreateMainPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.materialDataAttCreateMainPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品資料管理-主圖刪除
     */
    materialDataAttDeleteMainAttDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MaterialDataAtt/DeleteMainAtt`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品資料管理-主圖刪除
     */
    materialDataAttDeleteMainAttDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.materialDataAttDeleteMainAttDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品資料管理-編輯主圖(Att)
     */
    materialDataAttEditAttPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['mdaMaterialAttNo'] != null) {
                queryParameters['MdaMaterialAttNo'] = requestParameters['mdaMaterialAttNo'];
            }
            if (requestParameters['mdaCategoryKey'] != null) {
                queryParameters['MdaCategoryKey'] = requestParameters['mdaCategoryKey'];
            }
            if (requestParameters['attCategory'] != null) {
                queryParameters['AttCategory'] = requestParameters['attCategory'];
            }
            if (requestParameters['mdaAppendixName'] != null) {
                queryParameters['MdaAppendixName'] = requestParameters['mdaAppendixName'];
            }
            if (requestParameters['mdaOrder'] != null) {
                queryParameters['MdaOrder'] = requestParameters['mdaOrder'];
            }
            if (requestParameters['mdaAppendixSource'] != null) {
                queryParameters['MdaAppendixSource'] = requestParameters['mdaAppendixSource'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            const response = yield this.request({
                path: `/MaterialDataAtt/EditAtt`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品資料管理-編輯主圖(Att)
     */
    materialDataAttEditAttPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.materialDataAttEditAttPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    materialDataAttGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MaterialDataAtt/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    materialDataAttGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.materialDataAttGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品資料管理-商品主圖附件列表
     */
    materialDataAttGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MaterialDataAtt/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.MaterialDataAttSearchModelToJSON)(requestParameters['materialDataAttSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品資料管理-商品主圖附件列表
     */
    materialDataAttGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.materialDataAttGetPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.MaterialDataAttApi = MaterialDataAttApi;
